"use client";

import TFLayoutHomeSection from "@/Web/Components/TFLayoutHomeSection/TFLayoutHomeSection";
import { useTranslations } from "next-intl";

interface StatCardProps {
  number: string;
  title: string;
  description: string;
}

const StatCard = ({ number, title, description }: StatCardProps) => {
  return (
    <div className="bg-black/5 rounded-lg p-6 hover:bg-black/10 transition-colors h-full flex flex-col">
      <div className="text-4xl font-light text-black mb-2 tabular-nums">
        {number}
      </div>
      <h3 className="text-base font-semibold text-black mb-2 leading-tight">
        {title}
      </h3>
      <p className="text-sm text-black/60 leading-relaxed">{description}</p>
    </div>
  );
};

export default function SectionStats() {
  const t = useTranslations("web.pages.home.sections.stats");
  
  const stats = [
    {
      number: "350+",
      title: t("books"),
      description: t("booksDescription"),
    },
    {
      number: "150k+",
      title: t("comments"),
      description: t("commentsDescription"),
    },
    {
      number: "500+",
      title: t("videoLectures"),
      description: t("videoLecturesDescription"),
    },
    {
      number: "1500+",
      title: t("articles"),
      description: t("articlesDescription"),
    },
    {
      number: "50+",
      title: t("lecturers"),
      description: t("lecturersDescription"),
    },
    {
      number: "200+",
      title: t("lessonsPerMonth"),
      description: t("lessonsPerMonthDescription"),
    },
    {
      number: "20k+",
      title: t("havrutot"),
      description: t("havrutotDescription"),
    },
    {
      number: "300+",
      title: t("eventsPerMonth"),
      description: t("eventsPerMonthDescription"),
    },
  ];

  return (
    <TFLayoutHomeSection title={t("title")}>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        {stats.map((stat, index) => (
          <StatCard
            key={index}
            number={stat.number}
            title={stat.title}
            description={stat.description}
          />
        ))}
      </div>
    </TFLayoutHomeSection>
  );
}
